document.addEventListener("DOMContentLoaded", function () {

  const header = document.querySelector(".header");
  const menuItems = document.querySelectorAll(".header__inline-menu details");

  const primaryLogo = document.querySelector(".page-index .primary-logo");
  const megaLogo = document.querySelector(".logo_is_megamenu");

  menuItems.forEach((item) => {

    let closeTimer;

    // OPEN
    item.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);

      item.setAttribute("open", "");

      if (header) {
        header.classList.add("is_mgemnu_appear");
      }

      if (primaryLogo) primaryLogo.style.display = "none";
       // Show green logo ONLY if section 1 has NOT been crossed
  if (!window.headerPastTrigger && megaLogo) {
    megaLogo.style.display = "block";
  }
    });

    // CLOSE WITH DELAY
    item.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => {

         item.removeAttribute("open");
       // item.setAttribute("open", "");

        const anyOpen = document.querySelector(
          ".header__inline-menu details[open]"
        );

        if (!anyOpen && header) {
          header.classList.remove("is_mgemnu_appear");
        }

        if (primaryLogo) primaryLogo.style.display = "";
          if (megaLogo) {
      megaLogo.style.display = "none";
    }

      }, 300);
    });

  });

});